import service from '../request'
const baseUrl = window.globalUrl.HOME_API;
import qs from 'qs'
// 示例
// export const selectMyApprovalRecord = (params) => {
//   return service({
//     url: `${baseUrl}/trade-website/cqjy/selectMyApprovalRecord`,
//     method: 'get',
//     params:params,
//   })
// }
// export const SendMessage= (params) => {
//   return service({
//     url: `${baseUrl}/trade-website/online/send`,
//     method: 'post',
//     data: params,
//   })
// }
//获取农机、自营土地、托管土地列表
export const selectCompanyMachiner = (params) => {
  return service({
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/selectCompanyMachiner`,
    method: 'get',
    params:params,
  })
}
//查询作业环节和机手绑定关系
export const selectCropTypeMachinist = (params) => {
  return service({
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/selectCropTypeMachinist`,
    method: 'get',
    params:params,
  })
}
//查询托管单全程托管作业环节和机手绑定关系
export const selectOrderCropTypeMachinist = (params) => {
  return service({
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/selectOrderCropTypeMachinist`,
    method: 'get',
    params:params,
  })
}
//分配机手前置校验
export const assignOperatorsCheck = (params) => {
  return service({
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/assignOperatorsCheck`,
    method: 'post',
    data:params,
  })
}
//分配机手
export const assignOperators = (params) => {
  return service({
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/assignOperators`,
    method: 'post',
    data:params,
  })
}
//解绑机手
export const deleteAssignOperators = (params) => {
  return service({
    method: 'post',
    url: `${baseUrl}/trade-website/ldtp-machine-user-history/deleteAssignOperators`,
    data:params,
  })
}

//机手列表
export const selectMachineUser = (params) => {
  return service({
    url: `${baseUrl}/admin/sys-machine-user/selectMachineUser`,
    method: 'get',
    params:params,
  })
}

//查询可添加机手信息
export const selectUserAuth = (params) => {
  return service({
    url: `${baseUrl}/admin/sys-machine-user/selectUserAuth`,
    method: 'get',
    params:params,
  })
}

//认证机手
export const authFarmerMachinerUser = (params) => {
  return service({
    url: `${baseUrl}/admin/sys-machine-user/authFarmerMachinerUser`,
    method: 'post',
    data: qs.stringify(params),
  })
}

//添加机手
export const addMachineUser = (params) => {
  return service({
    url: `${baseUrl}/admin/sys-machine-user/addMachineUser`,
    method: 'post',
    data: params,
  })
}

//删除机手
export const deleteMachineUser = (params) => {
  return service({
    url: `${baseUrl}/admin/sys-machine-user/deleteMachineUser`,
    method: 'post',
    data: params,
  })
}
